import { RenownAppProfile as RenownAppProfileV1 } from "document-models/renown-app-profile/v1";
import { RenownCredential as RenownCredentialV1 } from "document-models/renown-credential/v1";
import { RenownOidcClient as RenownOidcClientV1 } from "document-models/renown-oidc-client/v1";
import { RenownOrganization as RenownOrganizationV1 } from "document-models/renown-organization/v1";
import { RenownUserStats as RenownUserStatsV1 } from "document-models/renown-user-stats/v1";
import { RenownUser as RenownUserV1 } from "document-models/renown-user/v1";

/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */

export const documentModels = [
  RenownAppProfileV1,
  RenownCredentialV1,
  RenownOidcClientV1,
  RenownOrganizationV1,
  RenownUserV1,
  RenownUserStatsV1,
] as const;
